module.exports = __webpack_public_path__ + "img/22jul6.46a44cf7.jpeg";